export default __webpack_public_path__ + "309db62233454f49a930c3c7e4850453.png";